import { render } from "./ModalAddTransporters.vue?vue&type=template&id=ee669fc8&scoped=true"
import script from "./ModalAddTransporters.vue?vue&type=script&lang=js"
export * from "./ModalAddTransporters.vue?vue&type=script&lang=js"

import "./ModalAddTransporters.vue?vue&type=style&index=0&id=ee669fc8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee669fc8"]])

export default __exports__